// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".n4N_t49Qem5sIVkOdYd1l{padding:2rem 0}._19lS6NBt2gGtHIG2XqA0w9{margin-top:1.2rem}._1nvi73W8M-QnlaHByDw8h8{padding:2rem 0}@media only screen and (min-width:992px){._2kqXGE0F6YYk-lBn0yIqwo{display:flex;justify-content:flex-end}._2kqXGE0F6YYk-lBn0yIqwo .scTdm8q9M2zY3nPb-k4Wv{flex-basis:0}}.scTdm8q9M2zY3nPb-k4Wv{margin:2rem 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle": "n4N_t49Qem5sIVkOdYd1l",
	"expandedText": "_19lS6NBt2gGtHIG2XqA0w9",
	"terms": "_1nvi73W8M-QnlaHByDw8h8",
	"buttonContainer": "_2kqXGE0F6YYk-lBn0yIqwo",
	"button": "scTdm8q9M2zY3nPb-k4Wv"
};
module.exports = ___CSS_LOADER_EXPORT___;
